import { useState } from "react";
import { SERVICES } from "../data";
import { useReveal } from "../hooks/useReveal";
import { Dialog, DialogContent } from "./ui/dialog";
import { ArrowUpRight } from "lucide-react";

export const Services = () => {
  const [ref, inView] = useReveal();
  const [active, setActive] = useState(null);

  return (
    <section id="servizi" data-testid="services-section" className="py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-[1400px] mx-auto">
        <div ref={ref} className={`max-w-2xl mx-auto text-center mb-16 reveal ${inView ? "in-view" : ""}`}>
          <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-5">I Nostri Servizi</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight leading-tight">
            Vetrate panoramiche &amp; vetrate su misura per ambienti indoor e outdoor.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <div
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`group relative overflow-hidden border border-black/10 reveal ${inView ? "in-view" : ""}`}
              style={{ animationDelay: `${i * 0.12}s` }}
            >
              <div className="h-[460px] overflow-hidden">
                <img
                  src={s.image}
                  alt={`${s.title} — vetrate panoramiche VETRO DESIGN ITALIA`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-white/75 backdrop-blur-md p-7 border-t border-white/40">
                <h3 className="font-serif text-2xl font-light mb-2">{s.title}</h3>
                <p className="text-sm text-foreground/70 font-light leading-relaxed mb-4">{s.teaser}</p>
                <button
                  data-testid={`service-more-${s.id}`}
                  onClick={() => setActive(s)}
                  className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] link-underline"
                >
                  Scopri di più
                  <ArrowUpRight strokeWidth={1.4} className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-2xl p-0 overflow-hidden gap-0" data-testid="service-dialog">
          {active && (
            <div>
              <div className="h-56 overflow-hidden">
                <img src={active.image} alt={`${active.title} — VETRO DESIGN ITALIA`} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <div className="p-8 max-h-[55vh] overflow-y-auto">
                <p className="text-xs uppercase tracking-[0.3em] text-champagne mb-3">Servizio</p>
                <h3 className="font-serif text-3xl font-light mb-5">{active.title}</h3>
                {active.full.split("\n\n").map((para, idx) => (
                  <p key={idx} className="text-foreground/75 font-light leading-relaxed mb-4">
                    {para}
                  </p>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
